import { useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';

import { useState } from 'react';
import { Button } from 'react-bootstrap';
import * as style from './ModalEditFact.module.less';
import { Tooltip } from 'react-tooltip';
import * as icons from '../NarrativeElement/icons/*.svg';

import { SupportingFact } from '@assets/model/NarrativeStore';
import { observable } from 'mobx';
import { formatModuleVariableName } from '@assets/utils/CompUtils';

interface ModalEditFactProps {
    fact: SupportingFact;
    onEdit: (fact: SupportingFact) => void;
}

class EditFactStore {
    @observable accessor fact: string;
    @observable accessor menuLabel: string;
    @observable accessor source: string;

    constructor(fact: SupportingFact) {
        this.fact = fact.exact_fact_quote;
        this.menuLabel = fact.ui_title ?? '';
        this.source = formatModuleVariableName(fact.fact_citation_source_file ?? '');
    }
}

export const ModalEditFact = observer((props: ModalEditFactProps) => {
    const [store] = useState(() => new EditFactStore(props.fact));

    return (
        <>
            <Flex fillCell={true} direction="column" alignItems="start">
                <div className={style.title}>Fact</div>
                <textarea
                    className={style.input}
                    style={{ minHeight: '150px', maxHeight: '350px' }}
                    value={store.fact}
                    onChange={e => {
                        store.fact = e.target.value;
                    }}
                />
                <div className={style.titleSmall}>Source</div>
                <input
                    className={style.input}
                    type="text"
                    value={store.source}
                    onChange={e => {
                        store.source = e.target.value;
                    }}
                />
                <div className={style.labelRow}>
                    <div className={style.titleSmall}>Menu label</div>
                    <img
                        src={icons['help']}
                        className={style.helpIcon}
                        data-tooltip-id="menu-label-help"
                        data-tooltip-content="Sets the alias for the tree navigation item in the side panel"
                        data-tooltip-place="top"
                    />
                </div>
                <input
                    className={style.input}
                    type="text"
                    value={store.menuLabel}
                    onChange={e => {
                        store.menuLabel = e.target.value;
                    }}
                />
                <Tooltip
                    id="menu-label-help"
                    positionStrategy="fixed"
                    className={style.helpTooltip}
                />
                <div style={{ flexGrow: 1 }}></div>
                <div className={style.seperator}></div>
                <Flex direction="row" style={{ width: '100%', height: '40px' }}>
                    <Button
                        onClick={() => {
                            const ui = useStoreUI();
                            ui.modal = null;
                        }}
                        className={style.cancelButton}
                    >
                        Cancel
                    </Button>
                    <div style={{ flexGrow: 1 }}></div>
                    <Button
                        onClick={() =>
                            props.onEdit({
                                ...props.fact,
                                exact_fact_quote: store.fact,
                                fact_citation_source_file: store.source,
                                ui_title: store.menuLabel
                            })
                        }
                        className={style.confirmButton}
                    >
                        Save
                    </Button>
                </Flex>
            </Flex>
        </>
    );
});
